import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message, SelectItem } from 'primeng/api';
import { PlanoContaEmpresa } from 'src/app/admihair/api/dto/plano-conta-empresa.';
import { PlanoContaGrupo } from 'src/app/admihair/api/dto/plano-conta-grupo';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { PlanoContaEmpresaService } from 'src/app/admihair/service/plano-conta-empresa.service';
import { PlanoContaGrupoService } from 'src/app/admihair/service/plano-conta-grupo.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-plano-conta-empresa-editar',
  templateUrl: './plano-contas-empresa-editar.component.html',
  styleUrls: ['./plano-contas-empresa-editar.component.scss']
})
export class PlanoContaEmpresaEditarComponent implements OnInit {
 
  messages: Message[] = [{ severity: 'success', summary: 'Sucesso', detail: 'Cliente salvo' }]; 
  messagemVisivel: boolean = false;
  progressoRequisicao: boolean = false;
  @Input() id?: number;
  @Output() emissor = new EventEmitter();
  prioridades: SelectItem[] = [{label: 'SIM', value: 1}, {label: 'NÃO', value: 0}];
  categoriasDre: string[] = ['CUSTOS FIXOS DIRETOS', 'CUSTOS FIXOS INDIRETOS',
     'CUSTOS VARIÁVEIS DIRETOS', 'CUSTOS VARIÁVEIS INDIRETOS', 'DESPESAS',
      'RECEITAS', 'NÃO PRESENTE'];
  utilizacoes: string[] = ['FOLHA DE PAGAMENTO', 'DESPESA', 'FOLHA/DESPESA', 'NÃO APLICADO'];
  referenciasFolha: string[] = ['CREDITO', 'DESCONTO', 'NÃO APLICADO'];
  planosContaGrupos: PlanoContaGrupo[] = [];
  planoContaEmpresa?: PlanoContaEmpresa;

  constructor(private utilStorageService: UtilStorageService,
    private planoContaEmpresaService: PlanoContaEmpresaService,
    private planoContaGrupoService: PlanoContaGrupoService,
    private erroService: ErroService) { }

  @ViewChild('f') form?: NgForm;
  value?: string;

  ngOnInit(): void {
    this.listarPlanosContaGrupos();
  }

  atualizar(){
    this.progressoRequisicao = true;
    this.planoContaEmpresaService.atualizar(this.planoContaEmpresa, this.id).subscribe({
      next: (data: PlanoContaEmpresa) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.rolarTela();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
      }
    })
  }

  carregarPlanoContaEmpresa(){
    this.planoContaEmpresaService.buscarPorId(this.id).subscribe({
      next: (data: PlanoContaEmpresa) => {
        this.planoContaEmpresa = data;
      }
    })
  }


  listarPlanosContaGrupos(){
    this.planoContaGrupoService.listarConfiguraveis().subscribe({
      next: (data: PlanoContaGrupo[]) => {
        this.planosContaGrupos = data;
        this.carregarPlanoContaEmpresa();
      },
      error: (err: any) => {
        console.log(err);
      }
    })
  }

  

  voltar(){
    this.emissor.emit({modo:'LISTAR'});
  }

  limparFormulario(){
    this.form?.reset(); 
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  
}
